<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const areaListTitle = '各地の黄砂レーダー'
</script>

<template>
  <div class="spotlist">
    <SectionTitle :title="areaListTitle" />
    <ul class="block">
      <li
        v-for="area in areaToPrefTable"
        :key="area.key"
        class="list"
      >
        <NuxtLink
          :to="`/${area.key}/`"
          class="title"
        >
          {{ area.name }}
        </NuxtLink>
        <ul
          v-if="Object.keys(area.pref_list).length > 0"
          class="parents"
        >
          <li
            v-for="pref in area.pref_list"
            :key="pref.key"
            class="inner"
          >
            <NuxtLink
              :to="`/${pref.key}/`"
              class="link"
            >
              {{ pref.name }}
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;
  }
  .list {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 8px 10px;
    background-color: #f9f9f9;
    &:nth-child(2n) {
      background-color: #eef1f8;
    }
  }
  .inner {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 3px;
  }
  .title {
    display: block;
    min-width: 53px;
    padding: 7px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    color: #303030;
    font-size: 13px;
    font-weight: 600;
    line-height: 1em;
    text-align: center;
  }
  .link {
    display: block;
    color: #3569c0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
    text-decoration: underline;
  }
  .parents {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    flex: 1;
  }
  .children {
    display: flex;
    align-items: center;
    gap: .7em;
  }
  .child {
    position: relative;
    &:not(:first-child)::before {
      position: absolute;
      top: 0;
      left: -.9em;
      width: 1em;
      height: 100%;
      color: #303030;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
      content: '・';
    }
  }
  .text {
    color: #303030;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
  }
  @media screen and (min-width: 830px) {
    .title {
      font-size: 13px;
      letter-spacing: normal;
      transition: box-shadow .2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px 0 rgb(0 0 0 / .45);
      }
    }
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
